import * as React from 'react';
import { TableCell } from 'types/common/table';
import { Member } from 'types/member';
import { getUtcUSFormatDateWithTime } from 'modules/utils/time';
import styled from 'styled-components';
import { DEFAULT_PAGE_SIZE } from 'constants/common';
import { getTableRowNumber } from 'modules/dataTable';
import CreateAnEmailVerificationLinkButton from './memberListCell/CreateAnEmailVerificationLinkButton';
import { getStatus } from 'containers/memberdetail/memberDetailGeneral/generalInformation/utils';
import { Link } from 'react-router-dom';

export const memberListColumns = (
  totalItems: number,
  currentPageIndex: number,
): TableCell<Member>[] => [
  {
    align: 'center',
    name: 'No.',
    key: 'no',
    render: (rowData, columnData, rowIndex) =>
      getTableRowNumber(totalItems, DEFAULT_PAGE_SIZE, currentPageIndex, rowIndex),
  },
  {
    align: 'center',
    name: 'Email',
    key: 'email',
    render: (rowData: Member) => (
      <MemberNameLink to={`/member/${rowData.userid}/general`}>
        <TextWrapper>{rowData.email}</TextWrapper>
      </MemberNameLink>
    ),
  },
  {
    align: 'center',
    name: 'Email Verification',
    key: 'EmailVerification',
    render: (rowData: Member) => {
      if (rowData.verifyToken === null) {
        return <TextWrapper>Verified</TextWrapper>;
      }

      return <CreateAnEmailVerificationLinkButton userId={rowData.userid} />;
    },
  },
  {
    align: 'center',
    name: 'Integration Status',
    key: 'integrationStatus',
    width: '50px',
    render: (rowData: Member) => {
      return rowData.isIntegrated ? 'Yes' : 'No';
    },
  },
  {
    align: 'center',
    name: 'CLO-SET Status',
    key: 'closetStatus',
    width: '110px',
    render: (rowData: Member) => {
      return getStatus(rowData.status);
    },
  },
  {
    align: 'center',
    name: 'Closet Marketing Agreement',
    key: 'marketingAgreement',
    width: '170px',
    render: (rowData: Member) => {
      return <>{rowData.marketingAgree ? 'Yes' : 'No'}</>;
    },
  },
  {
    align: 'center',
    name: 'Connect Marketing Agreement',
    key: 'marketingAgreement',
    width: '170px',
    render: (rowData: Member) => {
      return <>{rowData.connectMarketingAgree ? 'Yes' : 'No'}</>;
    },
  },
  {
    align: 'center',
    name: 'Registered Date',
    key: 'registeredDate',
    width: '220px',
    render: (rowData: Member) => getUtcUSFormatDateWithTime(rowData.registrationDate, true),
  },
];

const MarketingAgreementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const MemberNameLink = styled(Link)`
  text-decoration: underline;
  color: ${props => props.theme.palette.grey[900]};
  word-break: break-all;
`;

export const TextWrapper = styled.span`
  word-break: break-all;
`;
